const WORDS = [
  "Blocked Drains Perth",
  "5000 PSI Jetting",
  "Tree Roots Destroyed",
  "CCTV Inspection",
  "Book Online",
  "Upfront Pricing",
];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div
      data-testid="marquee-strip"
      className="overflow-hidden border-y-2 border-white/10 bg-[#09090b] py-5"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((w, i) => (
          <span key={i} className="flex items-center gap-10">
            <span
              className={`font-display text-3xl uppercase tracking-tight md:text-5xl ${
                i % 2 === 0 ? "text-outline-green" : "text-outline"
              }`}
            >
              {w}
            </span>
            <span className="h-3 w-3 rotate-45 bg-[#ff66c4]" />
          </span>
        ))}
      </div>
    </div>
  );
}
